import { useLayoutEffect, useEffect } from "react";
import { useLocation } from "react-router-dom";

// Hard reset scroll position to top on every route change.
// Runs synchronously before paint (useLayoutEffect) and again after to catch
// late image loads / Lenis re-synchronisation.
export default function ScrollToTop() {
    const { pathname } = useLocation();

    // Prevent the browser from auto-restoring scroll on history navigation.
    useEffect(() => {
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }
    }, []);

    useLayoutEffect(() => {
        if (typeof window === "undefined") return;
        // Stop Lenis from animating to its cached scroll position
        if (window.__lenis && typeof window.__lenis.stop === "function") {
            window.__lenis.stop();
        }
        // Native + Lenis reset to 0
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        if (window.__lenis && typeof window.__lenis.scrollTo === "function") {
            window.__lenis.scrollTo(0, { immediate: true, force: true });
        }
        // Re-enable Lenis on the next frame
        requestAnimationFrame(() => {
            if (window.__lenis && typeof window.__lenis.start === "function") {
                window.__lenis.start();
            }
        });
    }, [pathname]);

    // Safety pass after paint — catches any layout shifts from late image loads
    useEffect(() => {
        const t = setTimeout(() => {
            if (window.__lenis && typeof window.__lenis.scrollTo === "function") {
                window.__lenis.scrollTo(0, { immediate: true, force: true });
            }
            window.scrollTo(0, 0);
        }, 80);
        return () => clearTimeout(t);
    }, [pathname]);

    return null;
}
